import renameObjectKeys from './renameObjectKeys';
import flattenPromise from './flattenPromise';
import roleIdentifierComparator from './roleIdentifierComparator';
import generateUserAvatar from './generateUserAvatar';
import getToken from './getToken';
import * as crypto from './crypto';
import addPropOr from './addPropOr';

export {
  generateUserAvatar,
  renameObjectKeys,
  flattenPromise,
  roleIdentifierComparator,
  getToken,
  crypto,
  addPropOr,
};

export default {
  generateUserAvatar,
  renameObjectKeys,
  flattenPromise,
  roleIdentifierComparator,
  getToken,
  crypto,
  addPropOr,
};
